import { useState } from 'react';

const faqs = [
  {
    question: 'Do you offer web development in Nashville, TN?',
    answer:
      'Yes! GWDevelopers is based in the Nashville area and specializes in web development for Nashville small businesses. We serve all of Middle Tennessee including Downtown Nashville, East Nashville, Franklin, Brentwood, Murfreesboro, and Hendersonville.',
  },
  {
    question: 'How much does website design cost for a Nashville small business?',
    answer:
      'Our website build starts at $1,000 — a one-time fee for a professional, custom-designed website. Monthly management plans start at $50/month for hosting and $99/month for hosting plus unlimited updates. No hidden fees, no surprise bills.',
  },
  {
    question: 'What makes GWDevelopers different from other Nashville web design companies?',
    answer:
      'We use AI-powered web development to deliver professional websites faster and more affordably than traditional Nashville agencies. Most clients receive a live website preview within 24 hours. We also provide local SEO optimization so your Nashville business ranks in Google searches.',
  },
  {
    question: 'How long does it take to build a website in Nashville?',
    answer:
      'Most Nashville businesses have a live website preview within 24 hours of their consultation. Full launch typically happens within 1–2 weeks, compared to months with a traditional agency. Our AI-powered process speeds up every step.',
  },
  {
    question: 'Do you provide website hosting for Nashville businesses?',
    answer:
      'Yes — all websites we build come with professional hosting options. Our Basic Hosting Plan is $50/month and includes fast hosting, SSL security, and daily backups. Our Managed Plan at $99/month adds unlimited content updates and monthly performance reports.',
  },
  {
    question: 'What types of Nashville businesses do you build websites for?',
    answer:
      'We build websites for all types of Nashville small businesses including restaurants, home service companies (HVAC, plumbing, landscaping), professional services (law, accounting, consulting), health and wellness, retail, beauty salons, and more.',
  },
  {
    question: 'Will my website be optimized for local Nashville searches on Google?',
    answer:
      'Absolutely. Every website we build includes initial local SEO optimization targeting Nashville and your surrounding service areas. This helps your business show up when people in Nashville search for your services on Google.',
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const scrollToContact = () => {
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="faq" className="py-20 lg:py-32 bg-gradient-to-b from-black to-gray-950">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 lg:mb-16">
          <div className="inline-block px-4 py-2 bg-white/5 border border-white/10 rounded-full mb-6">
            <span className="text-sm text-gray-300 font-medium">FAQ</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-white mb-6">
            Frequently Asked Questions
          </h2>
          <p className="text-base sm:text-xl text-gray-400 max-w-2xl mx-auto">
            Common questions about web development and website design in Nashville, TN
          </p>
        </div>

        <div className="space-y-3 mb-12 lg:mb-16">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-white/10 rounded-2xl overflow-hidden"
            >
              <button
                onClick={() => toggle(index)}
                className="w-full flex items-center justify-between p-4 sm:p-6 text-left hover:bg-white/5 transition-colors duration-200 cursor-pointer"
              >
                <h4 className="text-white font-semibold text-sm sm:text-base pr-4 sm:pr-6">{faq.question}</h4>
                <div className="w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center border border-white/20 rounded-full flex-shrink-0 transition-transform duration-300"
                  style={{ transform: openIndex === index ? 'rotate(45deg)' : 'rotate(0deg)' }}>
                  <i className="ri-add-line text-white text-sm"></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-4 sm:px-6 pb-4 sm:pb-6">
                  <p className="text-gray-400 leading-relaxed text-sm sm:text-base">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center bg-gray-950 border border-white/10 rounded-2xl p-6 sm:p-10">
          <h3 className="text-xl sm:text-2xl font-bold text-white mb-3">Still have questions?</h3>
          <p className="text-gray-400 mb-6 text-sm sm:text-base">
            Reach out and we'll get back to you within 24 hours. Nashville small businesses are our specialty.
          </p>
          <div className="flex flex-col sm:flex-row flex-wrap gap-4 justify-center">
            <button
              onClick={scrollToContact}
              className="px-8 py-4 bg-white text-black font-bold rounded-lg hover:bg-gray-200 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Contact Us
            </button>
            <a
              href="tel:740-641-7292"
              className="px-8 py-4 border border-white/30 text-white font-semibold rounded-lg hover:border-white/60 transition-all duration-300 whitespace-nowrap cursor-pointer text-center"
            >
              Call 740-641-7292
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
